<template>
  <section class="token-invalid">
    <h2 class="label error">Invalid link</h2>
    <p>Sorry, Your password reset link is invalid.</p>
    <p>
      Please go to
      <router-link to="/aff-login">login</router-link>
      page and reset your password.
    </p>
    <router-link to="/aff-login" class="mt-8"><el-button>Go and Login</el-button></router-link>
  </section>
</template>
<script>
export default {
  name: 'token-invalid',
}
</script>
<style lang="scss">
.token-invalid{
  width: 450px;
  margin: 0 auto;
  line-height: 1.5;
}
</style>
